<div class="memo-page">
    <div class="filter-search">
        <div class="filter-title">
            <h3>Filtres</h3>
        </div>
        <frg-search-input (search)="onSearch($event)"></frg-search-input>
    </div>
    <div class="filters">
        <label>
            <input type="checkbox" [(ngModel)]="hideNew" (change)="refreshMemos()">
            Masquer les mémos en cours
            <span class="checkMark"></span>
        </label>
        <label>
            <input type="checkbox" [(ngModel)]="hideProcessed" (change)="refreshMemos()">
            Masquer les mémos traités
            <span class="checkMark"></span>
        </label>
        <label>
            <input type="checkbox" [(ngModel)]="hideDisabled" (change)="refreshMemos()">
            Masquer les mémos archivés
            <span class="checkMark"></span>
        </label>
    </div>
    <div class="memo-table">
        <frg-table [keysColumn]="memoColumnTable" [keysBody]="memoList" (onClickRow)="openMemo($event)"
        [isRowsClickable]="true" (onChangePage)="onChangePage($event)"></frg-table>
    </div>
</div>
